(() => {
  const T = (k, d, a) => (window.TalasT ? window.TalasT(k, d, a) : d);
  // app/scripts/pickup-availability.js
  if (!customElements.get("pickup-availability")) {
    customElements.define("pickup-availability", class PickupAvailability extends HTMLElement {
      constructor() {
        super();
        this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }
      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
        fetch(variantSectionUrl).then((response) => response.text()).then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
          this.renderPreview(sectionInnerHTML);
        }).catch((e) => {
          const button = this.querySelector("button");
          if (button)
            button.removeEventListener("click", this.onClickRefreshList);
          this.renderError();
        });
      }
      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }
      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);
        this.querySelector("button").addEventListener("click", this.onClickRefreshList);
      }
      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector("pickup-availability-drawer");
        if (drawer)
          drawer.remove();
        if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }
        this.innerHTML = sectionInnerHTML.querySelector("pickup-availability-preview").outerHTML;
        this.setAttribute("available", "");
        document.body.appendChild(sectionInnerHTML.querySelector("pickup-availability-drawer"));
        const button = this.querySelector("button");
        if (button)
          button.addEventListener("click", (evt) => {
            document.querySelector("pickup-availability-drawer").show(evt.currentTarget);
          });
      }
    });
  }
  if (!customElements.get("pickup-availability-drawer")) {
    customElements.define("pickup-availability-drawer", class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.querySelector(".pickup-availability-drawer-button").addEventListener("click", () => {
          this.hide();
        });
        const overlay = this.querySelector(".pickup-availability_overlay");
        if (overlay)
          overlay.addEventListener("click", () => this.hide());
        const sortBtn = this.querySelector("[data-pk-sort]");
        if (sortBtn)
          sortBtn.addEventListener("click", () => this.sortNearest(sortBtn));
        // lazy map preview: the iframe is only created the first time a map panel is opened
        this.querySelectorAll("[data-pk-map]").forEach((d) => {
          d.addEventListener("toggle", () => {
            const frame = d.querySelector(".pk-map__frame");
            if (!d.open || frame.firstElementChild)
              return;
            const f = document.createElement("iframe");
            f.src = "https://maps.google.com/maps?q=" + d.dataset.lat + "," + d.dataset.lng + "&z=15&output=embed";
            f.title = d.dataset.title || T("map", "Map");
            f.loading = "lazy";
            f.tabIndex = -1;
            f.referrerPolicy = "no-referrer-when-downgrade";
            frame.appendChild(f);
          });
        });
        this.initSheetDrag();
      }
      disconnectedCallback() {
        document.body.classList.remove("pk-open");
        document.removeEventListener("keydown", this.onKeydown);
        document.body.removeEventListener("click", this.onBodyClick);
        document.querySelector("html").classList.remove("overflow-hidden");
      }
      // keep Tab focus inside the dialog while it is open
      trapFocus(evt) {
        const nodes = [...this.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')]
          .filter((el) => el.offsetParent !== null || el === document.activeElement);
        if (!nodes.length)
          return;
        const first = nodes[0], last = nodes[nodes.length - 1];
        const active = document.activeElement;
        if (!this.contains(active)) {
          evt.preventDefault();
          first.focus();
        } else if (evt.shiftKey && active === first) {
          evt.preventDefault();
          last.focus();
        } else if (!evt.shiftKey && active === last) {
          evt.preventDefault();
          first.focus();
        }
      }
      // swipe the sheet down to dismiss (mobile bottom sheet only; the handle and header are the grip)
      initSheetDrag() {
        const sheet = this.querySelector(".pickup-availability-container");
        const grips = [this.querySelector(".pk-grab"), this.querySelector(".pickup-availability-header")].filter(Boolean);
        let y0 = null, dy = 0;
        const mobile = () => window.matchMedia("(max-width: 640px)").matches;
        grips.forEach((g) => {
          g.addEventListener("touchstart", (e) => {
            if (!mobile() || e.target.closest("button"))
              return;
            y0 = e.touches[0].clientY;
            dy = 0;
            sheet.style.transition = "none";
          }, { passive: true });
          g.addEventListener("touchmove", (e) => {
            if (y0 === null)
              return;
            dy = Math.max(0, e.touches[0].clientY - y0);
            sheet.style.transform = "translateY(" + dy + "px)";
          }, { passive: true });
          const end = () => {
            if (y0 === null)
              return;
            y0 = null;
            sheet.style.transition = "";
            sheet.style.transform = "";
            if (dy > 90)
              this.hide();
          };
          g.addEventListener("touchend", end);
          g.addEventListener("touchcancel", end);
        });
      }
      // Dubai wall-clock (Asia/Dubai, UTC+4, no DST)
      dubaiNow() {
        try {
          const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Dubai", weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(new Date());
          const get = (t) => (parts.find((p) => p.type === t) || {}).value;
          const day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(get("weekday"));
          const mins = parseInt(get("hour"), 10) * 60 + parseInt(get("minute"), 10);
          return day < 0 || isNaN(mins) ? null : { day, mins };
        } catch (e) {
          return null;
        }
      }
      // status line, today timeline and week grid highlight for every card
      refreshHours() {
        const now = this.dubaiNow();
        if (!now)
          return;
        const { day, mins } = now;
        const DAYS = [["sun", "Sun"], ["mon", "Mon"], ["tue", "Tue"], ["wed", "Wed"], ["thu", "Thu"], ["fri", "Fri"], ["sat", "Sat"]].map((p) => T("dayshort_" + p[0], p[1]));
        const T0 = 6 * 60, T1 = 22 * 60;
        const toMin = (s) => { const m = s.split(":"); return parseInt(m[0], 10) * 60 + parseInt(m[1], 10); };
        const hhmm = (m) => String(Math.floor(m / 60)).padStart(2, "0") + ":" + String(m % 60).padStart(2, "0");
        const rangesOf = (li) => (li ? (li.dataset.hours.match(/\d{1,2}:\d{2}\s*[–-]\s*\d{1,2}:\d{2}/g) || []) : []).map((r) => r.split(/\s*[–-]\s*/).map(toMin));
        this.querySelectorAll("[data-pk-card]").forEach((card) => {
          const rows = card.querySelectorAll(".pk-hours__list li");
          if (!rows.length)
            return;
          rows.forEach((li) => li.classList.toggle("is-today", Number(li.dataset.day) === day));
          const byDay = (d) => card.querySelector('.pk-hours__list li[data-day="' + d + '"]');
          const ranges = rangesOf(byDay(day));
          const status = card.querySelector("[data-pk-status]");
          const text = card.querySelector("[data-pk-today]");
          const cur = ranges.find((r) => mins >= r[0] && mins < r[1]);
          const later = ranges.find((r) => r[0] > mins);
          status.classList.remove("is-open", "is-closed");
          if (cur) {
            text.textContent = T("open_now_closes", "Open now · closes %t%", { t: hhmm(cur[1]) });
            status.classList.add("is-open");
          } else {
            let msg = T("closed", "Closed");
            if (later) {
              msg = T("pk_closed_opens_t", "Closed · opens %t%", { t: hhmm(later[0]) });
            } else {
              for (let k = 1; k <= 7; k++) {
                const d = (day + k) % 7, r = rangesOf(byDay(d))[0];
                if (r) { msg = T("pk_closed_opens_dt", "Closed · opens %d% %t%", { d: (k === 1 ? T("tomorrow", "tomorrow") : DAYS[d]), t: hhmm(r[0]) }); break; }
              }
            }
            text.textContent = msg;
            status.classList.add("is-closed");
          }
          // timeline: filled segments across 06:00-22:00 plus a "now" marker
          const tl = card.querySelector("[data-pk-tl]");
          if (tl) {
            tl.querySelectorAll(".pk-tl__seg").forEach((n) => n.remove());
            const pct = (m) => Math.min(100, Math.max(0, ((m - T0) / (T1 - T0)) * 100));
            const marker = tl.querySelector(".pk-tl__now");
            ranges.forEach((r) => {
              const seg = document.createElement("span");
              seg.className = "pk-tl__seg";
              seg.style.left = pct(r[0]) + "%";
              seg.style.width = Math.max(0, pct(r[1]) - pct(r[0])) + "%";
              tl.insertBefore(seg, marker);
            });
            marker.hidden = mins < T0 || mins > T1;
            marker.style.left = pct(mins) + "%";
          }
        });
      }
      // the branch with the shortest ready time gets the "Fastest" highlight (only when times actually differ)
      markFastest() {
        const toMinutes = (t) => {
          const m = /(\d+)(?:\s*[–-]\s*\d+)?\s*(minute|hour|day|week)/i.exec(t || "");
          if (!m)
            return null;
          return parseInt(m[1], 10) * { minute: 1, hour: 60, day: 1440, week: 10080 }[m[2].toLowerCase()];
        };
        const cards = [...this.querySelectorAll("[data-pk-card]")].map((c) => {
          const e = c.querySelector("[data-pk-eta]");
          return { c, m: e ? toMinutes(e.dataset.pkEtaEn || e.dataset.pkEta) : null };
        });
        const vals = cards.filter((x) => x.m !== null).map((x) => x.m);
        const min = Math.min.apply(null, vals);
        const differs = vals.some((v) => v !== min);
        cards.forEach((x) => {
          const on = differs && x.m === min;
          x.c.classList.toggle("is-fastest", on);
          x.c.querySelector(".pk-fast").hidden = !on;
        });
      }
      // closest branch: UAE-only button (rendered by the section). Geolocation is requested on click, or silently when
      // the browser permission is already granted; the coordinates (3 dp) are cached in sessionStorage for the session.
      geoRead() {
        try {
          const v = JSON.parse(sessionStorage.getItem("talas_geo"));
          return v && isFinite(v.la) && isFinite(v.lo) ? { la: Number(v.la), lo: Number(v.lo) } : null;
        } catch (e) {
          return null;
        }
      }
      geoSave(la, lo) {
        try {
          sessionStorage.setItem("talas_geo", JSON.stringify({ la: Math.round(la * 1000) / 1000, lo: Math.round(lo * 1000) / 1000 }));
        } catch (e) {
        }
      }
      autoNearest() {
        const btn = this.querySelector("[data-pk-sort]");
        if (!btn)
          return;
        const cached = this.geoRead();
        if (cached) {
          this.applyNearest(btn, cached.la, cached.lo, false);
          return;
        }
        try {
          if (navigator.permissions && navigator.permissions.query)
            navigator.permissions.query({ name: "geolocation" }).then((s) => {
              if (s.state === "granted")
                this.sortNearest(btn);
            }).catch(() => {});
        } catch (e) {
        }
      }
      applyNearest(btn, la, lo, animate) {
        const rad = (d) => (d * Math.PI) / 180;
        const km = (a, b, c, d) => {
          const x = Math.sin(rad(c - a) / 2) ** 2 + Math.cos(rad(a)) * Math.cos(rad(c)) * Math.sin(rad(d - b) / 2) ** 2;
          return 12742 * Math.asin(Math.sqrt(x));
        };
        const list = this.querySelector(".pk-list");
        const cards = [...list.querySelectorAll("[data-pk-card]")].map((c) => ({
          c,
          top: c.getBoundingClientRect().top,
          d: c.dataset.lat ? km(la, lo, parseFloat(c.dataset.lat), parseFloat(c.dataset.lng)) : Infinity
        }));
        const sorted = cards.slice().sort((p, q) => p.d - q.d);
        const near = sorted.length && isFinite(sorted[0].d) ? sorted[0].c : null;
        sorted.forEach((x, i) => {
          list.appendChild(x.c);
          x.c.style.setProperty("--i", i);
          const el = x.c.querySelector("[data-pk-dist]");
          if (isFinite(x.d)) {
            el.textContent = T("km_away", "%d% km away", { d: x.d.toFixed(1) });
            el.hidden = false;
          }
          const on = x.c === near;
          x.c.classList.toggle("is-closest", on);
          x.c.querySelector(".pk-near").hidden = !on;
        });
        if (animate && !window.matchMedia("(prefers-reduced-motion: reduce)").matches && cards[0].c.animate)
          cards.forEach((x) => {
            const dy = x.top - x.c.getBoundingClientRect().top;
            if (dy)
              x.c.animate([{ transform: "translateY(" + dy + "px)" }, { transform: "none" }], { duration: 450, easing: "cubic-bezier(.22,.8,.24,1)" });
          });
        const label = btn.querySelector("span");
        btn.disabled = false;
        label.textContent = T("closest_shown", "Closest branch shown");
        btn.setAttribute("aria-pressed", "true");
        const note = this.querySelector("[data-pk-note]");
        note.classList.remove("is-error");
        note.textContent = "";
      }
      sortNearest(btn) {
        const note = this.querySelector("[data-pk-note]");
        const label = btn.querySelector("span");
        const fail = (denied) => {
          btn.disabled = false;
          label.textContent = T("find_closest", "Find closest branch");
          note.classList.add("is-error");
          note.textContent = denied
            ? T("loc_blocked", "Location blocked \u2014 enable it in your browser to see the closest branch")
            : T("loc_failed", "Couldn\u2019t get your location");
        };
        if (!navigator.geolocation) {
          fail(false);
          return;
        }
        btn.disabled = true;
        label.textContent = T("locating", "Locating\u2026");
        note.classList.remove("is-error");
        note.textContent = "";
        navigator.geolocation.getCurrentPosition((pos) => {
          const { latitude: la, longitude: lo } = pos.coords;
          this.geoSave(la, lo);
          this.applyNearest(btn, la, lo, true);
        }, (err) => fail(err && err.code === 1), { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });
      }
      handleBodyClick(evt) {
        const target = evt.target;
        if (target != this && !target.closest("pickup-availability-drawer") && !target.closest("#ShowPickupAvailabilityDrawer")) {
          this.hide();
        }
      }
      handleKeydown(evt) {
        if (evt.key === "Escape")
          this.hide();
        else if (evt.key === "Tab")
          this.trapFocus(evt);
      }
      hide() {
        this.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClick);
        document.removeEventListener("keydown", this.onKeydown);
        document.body.classList.remove("pk-open");
        if (this.focusElement) {
          this.focusElement.setAttribute("aria-expanded", "false");
          this.focusElement.focus();
        }
        document.querySelector("html").classList.remove("overflow-hidden");
      }
      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        document.body.classList.add("pk-open");
        document.body.addEventListener("click", this.onBodyClick);
        document.addEventListener("keydown", this.onKeydown);
        document.querySelector("html").classList.add("overflow-hidden");
        if (focusElement)
          focusElement.setAttribute("aria-expanded", "true");
        this.refreshHours();
        this.markFastest();
        this.autoNearest();
        // the drawer is visibility:hidden until its transition starts, so retry focus for a few frames
        const closeButton = this.querySelector(".pickup-availability-drawer-button");
        let tries = 0;
        const focusClose = () => {
          closeButton.focus();
          if (document.activeElement !== closeButton && this.hasAttribute("open") && ++tries < 20)
            requestAnimationFrame(focusClose);
        };
        focusClose();
      }
    });
  }
})();
